import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { ValidationStatus } from "./helperComponents";
import { ValidationSummaryProps } from "../types/confirmationTypes";
import styles from "../Confirmation.module.css";

export const ValidationSummary = ({
  isGeneralComplete,
  isSourceFileComplete,
  isValidationsComplete,
  isPgpDecryptionComplete,
  outputDestinationsCount,
  notificationsCount,
  canSave,
  showOverrideWarning
}: ValidationSummaryProps) => {
  return (
    <div className={styles.validationSummary}>
      <h3>
        Form Status
      </h3>
      <div className={styles.validationList}>
        <ValidationStatus isValid={isGeneralComplete} label="General Information" />
        <ValidationStatus isValid={isSourceFileComplete} label="Source File" />
        <ValidationStatus isValid={isValidationsComplete} label="Validations" />
        <ValidationStatus isValid={isPgpDecryptionComplete} label="PGP Decryption" />
        <ValidationStatus isValid={true} label={`Output Destinations (${outputDestinationsCount})`} />
        <ValidationStatus isValid={true} label={`Notifications (${notificationsCount})`} />
      </div>
      
      {!canSave && !showOverrideWarning && (
        <div className={styles.warningMessage}>
          <FontAwesomeIcon icon={faExclamationTriangle} className={styles.warningIcon} />
          <span>Please complete all required sections before saving.</span>
        </div>
      )}
    </div>
  );
};